module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Johnny Honaker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Author and speaker "), _c('B', [_vm._v("Johnny Honaker")]), _vm._v(" pastors, along with his wife, CC (Cecilia), a growing multicultural church in the greater Tampa Bay area. Johnny is anointed to bring a message of hope and restoration to the broken and wounded of the nations. His love and passion for people allow him to see beyond the hurt and brokenness of shattered lives to the potential and greatness in them. He is a voice of hope in the midst of what has the appearance of a hopeless situation in the lives of men and women. Johnny and CC reside in Riverview, Florida, and have two married children.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/74QOVa/images/cover.jpg?1652115867476",
      "alt": "This image is the cover for the book The Enemy In You"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Enemy In You\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("You have been through the storms of life and have achieved victory, but an empty feeling lingers. It could be you have to recover what Satan has plundered from you."), _c('br'), _c('br'), _vm._v(" In "), _c('i', [_vm._v("The Enemy in You")]), _vm._v(", Pastor Johnny Honaker takes you on a journey from brokenness to wholeness. As God brings healing, you will ascend from the ashes and ruins of pain and calamity to achieve your personal destiny."), _c('br'), _c('br'), _vm._v(" THIS BOOK EQUIPS YOU TO:• Recover your identity in Christ from the clutches of the enemy"), _c('br'), _vm._v(" • Understand the source of pain and overcome it"), _c('br'), _vm._v(" • Demolish the invisible walls that keep you emotionally chained"), _c('br'), _vm._v(" Ask the HOLY SPIRIT to identify and confront the brokenness in your life, and walk out of hardship with your hands full of God’s blessings.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Charisma Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae7676c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0